import { render, staticRenderFns } from "./paypal.svg.vue?vue&type=template&id=bb3633aa&"
import script from "./paypal.svg.vue?vue&type=script&lang=js&"
export * from "./paypal.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports